//import node packages
import { useRef, useEffect } from 'react'
import qs from 'qs'

//import utility functions

import { ADMIN_AJAX_URL, getSiteAxios } from './axios'
import {getAttributes,getServiceTypeFromProductConfig} from "./configuration"
import {getPriceByBillingCycleID} from "./billingCycle"

//page types

export const ADD_PRODUCT_PAGE = 'ADD_PRODUCT_PAGE'
export const EDIT_PRODUCT_PAGE = 'EDIT_PRODUCT_PAGE'
export const ADD_DOMAIN_PAGE = 'ADD_DOMAIN_PAGE'
export const EDIT_DOMAIN_PAGE = 'EDIT_DOMAIN_PAGE'


//message code
export const ERR_SERVICE_EXISTS = 'ERR_SERVICE_EXISTS'
export const INFO_PROMO_REMOVED = 'INFO_PROMO_REMOVED'

//locale config
export const LOCALE_STRING_OPTIONS = {maximumFractionDigits: 2, minimumFractionDigits: 2}
export const LOCALE_LANG_OPTIONS = 'en-AU';


//livechat

export const moveLiveChatStyling = (maximized) => {
  //move live chat a bit so it's not covering checkout button
  if (maximized) { return '<style type="text/css"></style>'}
  return '<style type="text/css">' +
    '#chat-widget-container{bottom: 120px !important;     max-height: calc(100vh - 120px) !important;}' +
    '#livechat-eye-catcher{bottom: 135px !important;}' +
      '@media (min-width: 1200px) and (max-height: 770px){' +
          '#chat-widget-container{bottom: auto !important;top:  100px !important;     max-height: calc(100vh - 100px) !important;}' +
          '#livechat-eye-catcher{bottom: auto !important;top:  100px !important;}' +
      '}'+
      '@media (max-width: 768px){' +
        '#chat-widget-container{bottom: auto !important;top: 50px !important;    max-height: calc(100vh - 50px) !important;}' +
        '#livechat-eye-catcher{bottom: auto !important;top:  50px !important; }' +
      '}'+
    '</style>'
}

export const openLiveChat = () => {
  //open the livechat window
  if (typeof window.LC_API !== "undefined") {
    window.LC_API.open_chat_window();
  }
}


//site connector

export const convertConfigOptionsToObject = (config, productConfig) => {
  //convert selected config options in site connector from "friendly name" to "mercury payload"
  if (config && typeof productConfig.selectedProduct !== "undefined" &&
      getAttributes(productConfig.selectedProduct)) {
    const {config_options} = getAttributes(productConfig.selectedProduct)
    return Object.keys(config).map(key => {
      if (config_options && config_options.length) {
        const selectedConfig = config_options.find(i => i.name === key)
        if (selectedConfig && selectedConfig.options && selectedConfig.options.length) {
          const selectedOption = selectedConfig.options.find(i => i.name === config[key])
          if (selectedOption) {
            return ({
              config_id: selectedConfig.id,
              option_id: selectedOption.id
            })
          }
        }
      }
      return ({})
    })
  }
  return undefined
}


//manage slug

export const getSlugByName = (name) => {
  if (name) {
    const item_slug = name.toLowerCase().split(' ').join('_')
    return item_slug
  }
  return null
}

export const getIconSlugByName = (name) => {
  if (name) {
    return name
      .toLowerCase()
      .replace(/ /g, '-')
      .replace(/_/g, '-')
      .replace(/[^\w-]+/g, '')
  }
  return null
}


//manage DOM

export const usePrevious = (value) => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export const isMobileViewport = viewport => {
  if (viewport === 'xs' || viewport === 'sm') {
    return true
  }
  return false
}

export const getElementRefValue = (ref) => {
  return ref && ref.current? ref.current.value : null
}

export let removeSpinner = container => {
  if (container.childNodes && container.childNodes.length) {
    const children = Array.from(container.childNodes)
    children.forEach(item => {
      if (item.className && item.className.indexOf('z-spinner--css') !== -1) {
        container.removeChild(item)
      }
    })
  }
}

export const checkStepHeight = (elementRef) => {
  if (elementRef && elementRef.current) {
    let contentheight = 0
    if (elementRef.current.children && elementRef.current.children.length > 0) {
      const childrenList = Array.from(elementRef.current.children)
      childrenList.forEach(item => {
        const position = window.getComputedStyle(item).getPropertyValue('position')
        if (position !== 'fixed' && position !== 'absolute') {
          contentheight += item.clientHeight
        }
      })
      //offset
      if (contentheight > 0) {
        contentheight += 250
      }
    }

    if (window.innerHeight < contentheight) {
      if (elementRef.current.classList && elementRef.current.classList.length > 0) {
        const list = Array.from(elementRef.current.classList)
        if (!list.find(i => i === 'of-step--long')) {
          elementRef.current.classList.add('of-step--long')
        }
      } else {
        if (elementRef.current.classList) {
          elementRef.current.classList.add('of-step--long')
        }
      }
    }

    if (window.innerHeight > contentheight) {
      if (elementRef.current.classList && elementRef.current.classList.length > 0) {
        const list = Array.from(elementRef.current.classList)
        if (list.find(i => i === 'of-step--long')) {
          elementRef.current.classList.remove('of-step--long')
        }
      }
    }
  }
}

export const addCssClass = (el, className) => {
  if (el && el.classList && el.classList.length) {
    const list = Array.from(el.classList)
    if (!list.find(i => i === className)) {
      el.classList.add(className)
    }
  } else {
    if (el && el.classList) {
      el.classList.add(className)
    }
  }
}

export const removeCssClass = (el, className) => {
  if (el && el.classList && el.classList.length) {
    const list = Array.from(el.classList)
    if (list.find(i => i === className)) {
      el.classList.remove(className)
    }
  }
}

export const addClassToDOM = (el, className) => {
  if (el && el.classList && el.classList.length > 0 && !el.classList.contains(className)) {
    el.classList.add(className)
  }
}

export const removeClassToDOM = (el, className) => {
  if (el && el.classList && el.classList.length > 0 && el.classList.contains(className)) {
    el.classList.remove(className)
  }
}

export const getLoremIpsum = () => {
  return ('Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua')
}

export const toCamelCase = function (str) {
  return str.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase() })
}

//Tab Key Control

const onTabKeyPress = (e) => {
  if (e.keyCode === 9) {
    e.preventDefault()
  }
}

export const disableTab = () => {
  document.addEventListener('keydown',onTabKeyPress)
}

export const enableTab = () =>{
  document.removeEventListener('keydown',onTabKeyPress)
}

export const isHTML = str => {
  var a = document.createElement('div');
  a.innerHTML = str;

  for (var c = a.childNodes, i = c.length; i--; ) {
    if (c[i].nodeType === 1) return true;
  }

  return false;
}

//google

export const checkGA = () => {
  let checks = {}
  let failure = false
  let googleVariables = {
    google_tag_manager: 'object',
    google_tag_data: 'object',
    GoogleAnalyticsObject: 'string',
    ga: 'function',
    gaplugins: 'object',
    gaGlobal: 'object',
    gaData: 'object'
  }
  if (googleVariables && Object.entries(googleVariables).length > 0) {
    Object.keys(googleVariables).forEach(key => {
      if (typeof (window[key]) !== 'undefined') {
        if (typeof (window[key]) === googleVariables[key]) {
          checks[key] = 'pass'
        } else {
          checks[key] = 'soft-pass typeof was:' + typeof (window[key])
          failure = true
        }
      } else {
        checks[key] = `${key} Data was undefined`
        failure = true
      }
    })
  }
  // Check the results
  if (failure) {
    return checks
  } else {
    return 'all passed'
  }
}

export const setDataToGoogle = (cart, invoiceid, configurations) => {
  // Checks if GA functions and objects are loading in
  if (cart && cart.items && invoiceid) {
    const getProducts = () => {
      if (cart.items && cart.items.length > 0) {
        return cart.items.map((item) => {
          const { id, total_amount, discount, uuid, billing_cycle_id, order_type } = item
          const productConfig = configurations[uuid]
          const service_type = getServiceTypeFromProductConfig(productConfig)
          const getDomainName = () => {
            const { name } = item
            return name ? name : ''
          }
          const getVariant = () => {
            if (productConfig && productConfig.selectedProduct && productConfig.selectedProduct.attributes) {
              const { price } = productConfig.selectedProduct.attributes
              const billingCycle = getPriceByBillingCycleID(price, billing_cycle_id)
              if (billingCycle && billingCycle.name) {
                return getDomainName() + ' - ' + billingCycle.name
              }
            }
            return getDomainName()
          }
          const getProductName = () => {
            if (productConfig && productConfig.selectedProduct && productConfig.selectedProduct.attributes) {
              const { name } = productConfig.selectedProduct.attributes
              if (service_type === 'domain' && order_type) {
                return toCamelCase(order_type) + ' ' + name
              }
              return name
            }
            return service_type
          }
          const getBrand = () => {
            if (productConfig && productConfig.selectedProduct && productConfig.selectedProduct.attributes) {
              if (service_type === 'domain' && order_type) {
                return toCamelCase(service_type)
              }
              const { group } = productConfig.selectedProduct.attributes
              if (group && group.name) {
                return group.name
              }
            }
            return service_type
          }
          return ({
            name: getProductName(),
            id: id,
            price: total_amount,
            brand: getBrand(),
            category: service_type,
            variant: getVariant(),
            quantity: 1,
            coupon: discount ? discount : ''
          })
        })
      }
      return null
    }
    const getTotalAmount = () => {
      if (cart && cart.total_amount) {
        return cart.total_amount
      }
      return '0.00'
    }
    const getTax = () => {
      if (cart && cart.total_amount) {
        const tax = parseFloat(cart.total_amount) / 10
        return tax.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)
      }
      return '0.00'
    }
    const getCoupon = () => {
      let coupon = ''
      if (cart.items && cart.items.length > 0) {
        cart.items.forEach((item) => {
          const { discount } = item
          if (discount) {
            coupon = discount
          }
        })
      }
      return coupon
    }
    const googlePayload = {
      event: 'order.completed',
      ecommerce: {
        purchase: {
          actionField: {
            id: invoiceid,
            affiliation: 'Website',
            revenue: getTotalAmount(),
            tax: getTax(),
            shipping: '0.00',
            coupon: getCoupon()
          },
          products: getProducts()
        }
      }
    }
    window.dataLayer.push(googlePayload)
    if (checkGA() !== 'all passed') {
      const result = checkGA()
      const payload = {
        action: 'log_gtm_error',
        invoiceid,
        result
      }
      getSiteAxios().post(`${ADMIN_AJAX_URL}`, qs.stringify(payload))
    }
  }
}

export const isAUDomain = tld =>{
  return tld && tld.indexOf(".au") !== -1
}